// DestinationsSection.js
import React from 'react';
import { motion } from 'framer-motion';
// Also import any images, data, or components used in the destination section here

      export const demoDestinations = [
        {
          id: 'maharashtra',
          title: 'Maharashtra – A Majestic Mosaic of Cities, Forts, Forests & Coasts',
          images: ['/maharashtra.jpg', '/maharashtra2.jpg', '/maharashtra3.jpg', '/maharashtra4.jpg', '/maharashtra5.jpg', '/maharashtra6.jpg', '/maharashtra7.jpg'],
          summary: 'Maharashtra is a complete package, vibrant cities, lush hill stations, historic forts, ancient caves, spiritual towns, wildlife sanctuaries, and sun-kissed beaches.',

          },
        {
          id: 'Uttarakhand',
          title: 'Uttarakhand – The Land of Gods and Untamed Nature',
          images: ['/utta1.jpg', '/utta2.jpg', '/utta3.jpg', '/utta4.jpg', '/utta5.jpg'],
          summary: 'Known as Dev Bhoomi, Uttarakhand is a mystical blend of spirituality, natural beauty, adventure, and culture. From the sacred ghats of Rishikesh and Haridwar to the snow-capped peaks of Auli and the hidden gems of Kumaon, the state offers something for every traveler.',
          
        },
        {
          id: 'Goa',
          title: 'Goa – Sun, Sand, and Susegad Vibes',
          images: ['/goa1.jpg', '/goa2.jpg', '/goa3.jpg', '/goa4.jpg', '/goa5.jpg', '/goa6.jpg'],
          summary: 'Goa is India’s favorite beach paradise. But beyond the beaches, there is a soul in its Portuguese heritage, cozy villages, spice farms, and bohemian markets. Whether you want the nightlife or nature, Goa lets you do both at your pace.',
        },
        {
          id: 'Uttar Pradesh',
          title: 'Uttar Pradesh – Land of Spirituality, History & Heritage',
          images: ['/up1.jpg', '/up2.jpg', '/up3.jpg', '/up4.jpg', '/up5.jpg', '/up6.jpg', '/up7.jpg'],
          summary: 'Uttar Pradesh is one of Indias most culturally and spiritually significant states. Known as the land where the epic stories of Ramayana and Mahabharata come alive, it is home to revered pilgrimage towns, magnificent Mughal monuments, and vibrant festivals.',
        },
        {
          id: 'Tamil Nadu',
          title: 'Tamil Nadu – The Land of Temples',
          images: ['/tn1.jpg', '/tn2.jpg', '/tn3.jpg', '/tn4.jpg', '/tn5.jpg', '/tn6.jpg', '/tn7.jpg'],
          summary: 'Tamil Nadu boasts a rich cultural heritage with magnificent Dravidian-style temples, classical art forms, and UNESCO-listed monuments. The state also features serene hill stations and scenic coastal towns.',
        },
        {
          id: 'Rajasthan',
          title: 'Rajasthan – A Royal Canvas of Colors, Culture & Desert Magic',
          images: ['/raj1.jpg', '/raj2.jpg', '/raj3.jpg', '/raj4.jpg', '/raj5.jpg'],
          summary: 'Rajasthan, the Land of Kings, is where grandeur meets tradition. With majestic forts, golden deserts, colorful cities, and vibrant local life, it offers a regal yet grounded travel experience.',
        },
        {
          id: 'Andaman & Nicobar Islands',
          title: 'Andaman & Nicobar Islands',
          images: ['/ani1.jpg', '/ani2.jpg', '/ani3.jpg', '/ani4.jpg', '/ani5.jpg','/ani6.jpg'],
          summary: 'A tropical paradise in the Bay of Bengal, the Andaman & Nicobar Islands are known for their white sandy beaches, turquoise waters, coral reefs, rich marine life, and colonial history.',
        },
        {
          id: 'North-East',
          title: 'North-East India (The Seven Sisters + Sikkim)',
          images: ['/ne1.jpg', '/ne2.jpg', '/ne3.jpg', '/ne4.jpg', '/ne5.jpg'],
          summary: 'Explore the untouched beauty, cultural richness, and diverse landscapes of North-East India. Each state offers unique experiences from lush green valleys, vibrant tribal culture, serene monasteries, snow-covered mountains, to wildlife sanctuaries. Perfect for nature lovers, adventure seekers, and those looking for peaceful retreats.',
        },
        {
          id: 'Ladakh',
          title: 'Ladakh – Land of High Passes',
          images: ['/lad1.jpg', '/lad2.jpg', '/lad3.jpg', '/lad4.jpg', '/lad5.jpg'],
          summary: 'A surreal blend of rugged mountains, ancient monasteries, and crystal-clear lakes, Ladakh is India’s ultimate adventure and soul-searching destination. Situated at over 11,000 feet, Ladakh offers raw beauty, unmatched landscapes, and an unforgettable cultural experience.',
        },
        {
          id: 'Himachal Pradesh',
          title: 'Himachal Pradesh – Where the Hills Whisper Stories',
          images: ['/hp1.jpg', '/hp2.jpg', '/hp3.jpg', '/hp4.jpg', '/hp5.jpg'],
          summary: 'A land of towering mountains, alpine meadows, winding rivers, and charming hill towns. Himachal Pradesh is a versatile destination offering something for every kind of traveler. Whether you are seeking adventure, peace, snowfall, or cafes with a view, Himachal has it all.',
        },
        {
          id: 'Kerala',
          title: 'Kerala – God’s Own Country',
          images: ['/ker1.jpg', '/ker2.jpg', '/ker3.jpg', '/ker4.jpg', '/ker5.jpg'],
          summary: 'Kerala is a paradise of lush greenery, serene backwaters, spice-scented hills, and palm-fringed beaches. Known for its Ayurveda treatments, Kathakali performances, and delicious coastal cuisine, Kerala offers a perfect blend of relaxation and cultural experiences.',
        },
        {
          id: 'Punjab',
          title: 'Punjab – The Land of Five Rivers & Pure Vibes',
          images: ['/pun1.jpg', '/pun2.jpg', '/pun3.jpg', '/pun4.jpg'],
          summary: 'Punjab is where rich culture, soulful music, hearty food, and vibrant festivals come alive. Known for its golden fields, warm-hearted people, and spiritual heritage, Punjab is perfect for travelers who want an authentic and energetic North Indian experience.',
        },
        {
          id: 'Delhi',
          title: 'Delhi – A City Where Every Turn Tells a Story',
          images: ['/del1.jpg', '/del2.jpg', '/del3.jpg', '/del4.jpg'],
          summary: 'Delhi, the capital of India, is where ancient history blends seamlessly with modern life. From Mughal-era forts to vibrant street markets and high-rise cafes, Delhi offers travelers a deep dive into India’s culture, food, and politics.',
        },
        {
          id: 'Karnataka',
          title: 'Karnataka – A Blend of Heritage and Nature',
          images: ['/karna1.jpg', '/karna2.jpg', '/karna3.jpg', '/karna4.jpg', '/karna5.jpg'],
          summary: 'From ancient temples and royal palaces to lush coffee plantations and national parks, Karnataka offers a diverse experience to travelers.',
        }
      ];
      
      // Destination data for Global
      export const globalDestinations = [
        {
          id: 'thailand',
          title: 'Thailand – A Tropical Paradise of Islands, Temples & Street Food',
          images: ['/thailand.jpg', '/thailand2.jpg', '/thailand3.jpg', '/thailand4.jpg', '/thailand5.jpg', '/thailand6.jpg', '/thailand7.jpg'],
          summary: 'Thailand offers a vibrant blend of exotic beaches, ornate temples, bustling markets, and world-famous cuisine.',
        },
        {
          id: 'maldives',
          title: 'Maldives – A Slice of Paradise in the Indian Ocean',
          images: ['/maldives.jpg', '/maldives4.jpg', '/maldives3.jpg', '/maldives2.jpg'],
          summary: 'Dreamy island known for its turquoise blue waters, luxurious overwater villas, and marine life. Perfect for honeymooners, families, solo travelers, and divers alike.',
        },
        {
          id: 'kenya',
          title: 'Kenya – The Heart of African Safaris & Stunning Landscapes',
          images: ['/Kenya.jpg', '/Kenya2.jpg', '/Kenya3.jpg', '/Kenya4.jpg', '/Kenya5.jpg', '/Kenya6.jpg'],
          summary: 'Kenya is where the wild roams free and nature dazzles at every turn. From wildlife encounters to serene beach holidays, it’s the ultimate adventure.',
        },
        {
          id: 'UAE',
          title: 'United Arab Emirates (UAE): A Land of Luxury,Culture & Desert Dreams',
          images: ['/dubai2.jpg', '/dubai1.jpg', '/dubai3.jpg', '/dubai4.jpg', '/dubai5.jpg'],
          summary: 'UAE is a dazzling fusion of futuristic architecture, luxurious experiences, golden deserts, and deeply rooted Arabian culture. From the towering Burj Khalifa in Dubai to grand Sheikh Zayed Mosque in Abu Dhabi, UAE offers world-class shopping, beach escapes, cultural heritage, or desert adventures.',
        },
        {
          id: 'Indonesia',
          title: 'Indonesia – Islands of Wonders and Endless Adventures',
          images: ['/Indonesia1.jpg', '/Indonesia2.jpg', '/Indonesia3.jpg', '/Indonesia4.jpg', '/Indonesia5.jpg'],
          summary: 'Indonesia is a magical archipelago made up of over 17,000 islands, offering an incredible diversity of landscapes, cultures, and experiences.',
        },
        {
          id: 'Vietnam',
          title: 'Vietnam: A Mosaic of Culture, History & Scenic Wonders',
          images: ['/Viet1.jpg', '/viet2.jpg', '/viet3.jpg', '/viet4.jpg', '/viet5.jpg'],
          summary: 'Vietnam is a vibrant Southeast Asian country known for its lush landscapes, bustling cities, rich history, and delectable cuisine.',
        },
        {
          id: 'Turkey',
          title: 'Turkey: Where East Meets West',
          images: ['/tur1.jpg', '/tur2.jpg', '/tur3.jpg', '/tur4.jpg', '/tur5.jpg','/tur6.jpg'],
          summary: 'Turkey is a captivating blend of cultures, continents, and centuries of history. Straddling both Asia and Europe.Its a paradise for history lovers, culture enthusiasts, foodies, and nature seekers.',
        },
        {
          id: 'Sri Lanka',
          title: 'Sri Lanka: The Teardrop of the Indian Ocean',
          images: ['/sl1.jpg', '/sl2.jpg', '/sl3.jpg', '/sl4.jpg', '/sl5.jpg'],
          summary: 'A tropical paradise nestled just south of India, Sri Lanka offers a perfect blend of golden beaches, misty hill stations, ancient temples, wildlife safaris, and mouthwatering cuisine.',
        },
        {
          id: 'South Korea',
          title: 'South Korea – Where Tradition Meets Trend',
          images: ['/sk1.jpg', '/sk2.jpg', '/sk3.jpg', '/sk4.jpg', '/sk5.jpg'],
          summary: 'It is the perfect fusion of ancient heritage and futuristic innovation. From centuries-old palaces and hanok villages to K-pop concerts and smart cities, Korea offers a blend thats both dynamic and deeply rooted.',
        },
        {
          id: 'Singapore',
          title: 'Singapore: A Global City of Innovation, Culture & Green Spaces',
          images: ['/sing1.jpg', '/sing2.jpg', '/sing3.jpg', '/sing4.jpg', '/sing5.jpg'],
          summary: 'Known as one of the cleanest, most organized, and futuristic cities in the world, Singapore blends ultra-modern infrastructure with deep-rooted Asian traditions.',
        },
        {
          id: 'Malaysia',
          title: 'Malaysia: A Vibrant Blend of Cultures, Nature & Modernity',
          images: ['/malay1.jpg', '/malay2.jpg', '/malay3.jpg', '/malay4.jpg', '/malay5.jpg'],
          summary: 'Malaysia is one of Southeast Asias most diverse and exciting travel destinations where modern cities, tropical rainforests, stunning beaches, historic towns, and multicultural experiences come together.',
        },
        {
          id: 'Japan',
          title: 'Japan – Where Timeless Traditions Meet Futuristic Wonders',
          images: ['/jap1.jpg', '/jap2.jpg', '/jap3.jpg', '/jap4.jpg', '/jap5.jpg','/jap6.jpg'],
          summary: 'Japan is a country like no other, a place where centuries-old temples sit beside neon skyscrapers, and quiet bamboo forests lead to buzzing cities. It’s a land of rituals, respect, perfection, and extreme contrasts.',
        },
        {
          id: 'Qatar',
          title: 'Qatar – Where Tradition Meets Futuristic Elegance',
          images: ['/qat1.jpg', '/qat2.jpg', '/qat3.jpg', '/qat4.jpg', '/qat5.jpg'],
          summary: 'Qatar is a dynamic blend of ultra-modern cityscapes, rich Islamic culture, and the untouched beauty of deserts and the Arabian Gulf.Qatar has made a big name for itself with its world-class architecture, luxury shopping, vibrant art scene.',
        },
        {
          id: 'Kuwait',
          title: 'Kuwait – The Hidden Pearl of the Arabian Gulf',
          images: ['/ku1.jpg', '/ku2.jpg', '/ku3.jpg', '/ku4.jpg', '/ku5.jpg'],
          summary: 'It is a destination that surprises visitors with its deep-rooted Arab culture, coastal charm, modern elegance, and undiscovered travel gems, with its blend of traditional souqs, Islamic architecture, museums, and glittering seafronts.',
        },
        {
          id: 'Armenia',
          title: 'Armenia – The Hidden Gem of the Caucasus',
          images: ['/arme1.jpg', '/arme2.jpg', '/arme3.jpg', '/arme4.jpg', '/arme5.jpg'],
          summary: 'Armenia is a country where ancient traditions, spectacular landscapes, and soulful hospitality come together to create a truly unique travel experience.',
        },
        {
          id: 'Azerbaijan',
          title: 'Azerbaijan – The Land of Fire & Contrasts',
          images: ['/az1.jpg', '/az2.jpg', '/az3.jpg', '/az4.jpg'],
          summary: 'Azerbaijan, known as the “Land of Fire”, is a mesmerizing blend of East and West, where modern cities rise beside ancient Silk Road ruins, mud volcanoes bubble in alien-like landscapes, and eternal flames dance on hilltops.',
        },
        {
          id: 'Bahrain',
          title: 'Bahrain – The Island Nation of Culture, Pearls & Cosmopolitan Charm',
          images: ['/bah1.jpg', '/bah2.jpg', '/bah3.jpg', '/bah4.jpg', '/bah5.jpg'],
          summary: 'Bahrain, officially the Kingdom of Bahrain, is a captivating archipelago in the Persian Gulf known for its vibrant culture, historical depth, and modern elegance.It is a beautiful blend of ancient civilizations, luxury shopping, bustling souqs, and progressive Arab lifestyle.',
        },
        {
          id: 'Bhutan',
          title: 'Bhutan: The Last Great Himalayan Kingdom',
          images: ['/bhu1.jpg', '/bhu2.jpg', '/bhu3.jpg', '/bhu4.jpg', '/bhu5.jpg'],
          summary: 'Bhutan, often referred to as the "Land of the Thunder Dragon", is one of the world’s most unique travel destinations where tradition thrives, happiness is prioritized over GDP, and snow-capped Himalayan peaks rise over pristine valleys and ancient monasteries.',
        },
        {
          id: 'Cambodia',
          title: 'Cambodia: The Kingdom of Temples, Culture & Tranquility',
          images: ['/camb1.jpg', '/camb2.jpg', '/camb3.jpg', '/camb4.jpg', '/camb5.jpg'],
          summary: 'Cambodia is a land where ancient ruins rise out of jungles, rivers meet serene countryside, and rich traditions echo through the cities and villages. Best known for the iconic Angkor Wat, the largest religious monument in the world. Cambodia is much more than just temples.',
        },
        {
          id: 'Georgia',
          title: 'Georgia – Europe’s Hidden Gem in the Caucasus',
          images: ['/geo1.jpg', '/geo2.jpg', '/geo3.jpg', '/geo4.jpg', '/geo5.jpg', '/geo6.jpg', '/geo7.jpg', '/geo8.jpg'],
          summary: 'Georgia, a breathtaking country at the crossroads of Europe and Asia, is where snow-capped mountains meet lush vineyards, ancient monasteries cling to cliff sides, and hospitality flows as freely as its wine.',
        },
        {
          id: 'Hong Kong',
          title: 'Hong Kong – The City of Skylines, Culture & Culinary Wonders',
          images: ['/hk1.jpg', '/hk2.jpg', '/hk3.jpg', '/hk4.jpg', '/hk5.jpg', '/hk6.jpg', '/hk7.jpg'],
          summary: 'A dazzling fusion of East and West, tradition and modernity, Hong Kong is a destination that offers much more than its famous skyline. This autonomous region of China blends ancient temples and spiritual escapes with futuristic cityscapes, world-class shopping, thrilling theme parks, and unbeatable street food.',
        },
        {
          id: 'Jordan',
          title: 'Jordan – Where History, Desert & Hospitality Meet',
          images: ['/jor1.jpg', '/jor2.jpg', '/jor3.jpg', '/jor4.jpg'],
          summary: 'Jordan is one of the Middle East’s most magical destinations, a country steeped in biblical history, awe-inspiring ancient ruins, dramatic desert landscapes, and unmatched Arabian hospitality.',
        },
        {
          id: 'Kazakhstan',
          title: 'Kazakhstan – The Hidden Gem of Central Asia',
          images: ['/kaza1.jpg', '/kaza2.jpg', '/kaza3.jpg', '/kaza4.jpg', '/kaza5.jpg'],
          summary: 'Kazakhstan is an emerging destination that blends breathtaking natural beauty, Soviet-era history, ancient Silk Road roots, and futuristic cities.',
        },
        {
          id: 'Laos',
          title: 'Laos – The Laid-Back Jewel of Southeast Asia',
          images: ['/laos1.jpg', '/laos2.jpg', '/laos3.jpg', '/laos4.jpg', '/laos5.jpg'],
          summary: 'Laos is a landlocked country that feels like stepping back in time. Unlike its bustling neighbors, Laos offers a tranquil and slow-paced vibe, rich in Buddhist culture, lush nature, charming villages, and Mekong river life.',
        },
        {
          id: 'Lebanon',
          title: 'Lebanon – A Timeless Mosaic of Culture, History & Mediterranean Charm',
          images: ['/leb1.jpg', '/leb2.jpg', '/leb3.jpg', '/leb4.jpg', '/leb5.jpg', '/leb6.jpg', '/leb7.jpg'],
          summary: 'Lebanon is a small yet extraordinarily rich country nestled between the Mediterranean Sea and the mountains of the Middle East. It’s where Roman temples, Byzantine mosaics, Crusader castles, lively souks, beach clubs, and ski resorts all coexist',
        },
        {
          id: 'Macau',
          title: 'Macau – Where East Meets West in a Glittering Blend of Culture & Glamour',
          images: ['/mac1.jpg', '/mac2.jpg', '/mac3.jpg', '/mac4.jpg', '/mac5.jpg'],
          summary: 'Macau, often referred to as the "Las Vegas of Asia," is a fascinating fusion of Portuguese colonial heritage and vibrant Chinese traditions.Macau offers travelers a unique mix of the old and the new, all within a compact and easily walkable area.',
        },
        {
          id: 'Mongolia',
          title: 'Mongolia – Land of Eternal Blue Sky & Nomadic Heritage',
          images: ['/mong1.jpg', '/mong2.jpg', '/mong3.jpg', '/mong4.jpg', '/mong5.jpg'],
          summary: 'Mongolia is one of the last truly untamed frontiers on Earth. With vast steppes, dramatic deserts, alpine lakes, and a rich nomadic culture that has remained unchanged for centuries, Mongolia offers a once-in-a-lifetime escape into raw, majestic wilderness.',
        },
        {
          id: 'Nepal',
          title: 'Nepal: The Land of Mountains and Monasteries',
          images: ['/nep1.jpg', '/nep2.jpg', '/nep3.jpg', '/nep4.jpg', '/nep5.jpg'],
          summary: 'Nestled in the lap of the Himalayas, Nepal is a land of majestic mountains, spiritual sanctuaries, vibrant cultures, and untouched natural beauty. Whether you are looking for an adventurous trek to Everest Base Camp, a spiritual journey through centuries-old monasteries, or a relaxing escape in the hills, Nepal offers it all.',
        },
        {
          id: 'Oman',
          title: 'Oman – The Hidden Gem of the Arabian Peninsula',
          images: ['/oman1.jpg', '/oman2.jpg', '/oman3.jpg', '/oman4.jpg', '/oman5.jpg', '/oman6.jpg'],
          summary: 'Oman, often overshadowed by its flashier neighbors, is a land of mystical deserts, rugged mountains, pristine beaches, and rich traditions. It offers a rare glimpse into authentic Arabia untouched by mass tourism, deeply rooted in culture, and full of awe-inspiring natural landscapes.',
        },
        {
          id: 'Philippines',
          title: 'Philippines – Island Paradise of Southeast Asia',
          images: ['/phi1.jpg', '/phi2.jpg', '/phi3.jpg', '/phi4.jpg', '/phi5.jpg'],
          summary: 'The Philippines is a breathtaking archipelago of over 7,000 islands, each offering something uniquely stunning from white sandy beaches and turquoise waters, to volcano treks, rice terraces, and vibrant cities.',
        },
        {
          id: 'Russia',
          title: 'Russia – A Journey Through Time and Culture',
          images: ['/rus1.jpg', '/rus2.jpg', '/rus3.jpg', '/rus4.jpg', '/rus5.jpg', '/rus6.jpg'],
          summary: 'Russia, the worlds largest country, offers a vast tapestry of experiences from the imperial grandeur of Moscow and St. Petersburg to the serene landscapes of Lake Baikal and the rugged beauty of Kamchatka.',
        },
        {
          id: 'Saudi Arabia',
          title: 'Saudi Arabia – A Land of Sacred Sites, Desert Wonders & Cultural Rebirth',
          images: ['/sau1.jpg', '/sau2.jpg', '/sau3.jpg', '/sau4.jpg', '/sau5.jpg', '/sau6.jpg'],
          summary: 'A country of majestic deserts, ancient trade routes, Red Sea coastlines, and ultra-modern cities, Saudi Arabia offers an incredible mix of spiritual journeys, natural marvels, historic treasures, and futuristic visions like NEOM and Riyadh Expo 2030.',
        },
        {
          id: 'Taiwan',
          title: 'Taiwan – The Hidden Gem of East Asia',
          images: ['/tai1.jpg', '/tai2.jpg', '/tai3.jpg', '/tai4.jpg', '/tai5.jpg', '/tai6.jpg'],
          summary: 'Taiwan is where tradition meets technology, and nature dances with modernity. From its buzzing night markets and towering skyscrapers to serene temples and lush mountains, Taiwan offers a little of everything—culinary adventures, hot springs, rich culture, and scenic coastline.',
        },
        {
          id: 'Tajikistan',
          title: 'Tajikistan – The Mountain Wonderland of Central Asia',
          images: ['/taji1.jpg', '/taji2.jpg', '/taji3.jpg', '/taji4.jpg', '/taji5.jpg', '/taji6.jpg'],
          summary: 'Tajikistan, a hidden treasure tucked in the heart of Central Asia, is a dream destination for mountain lovers, cultural explorers, and adventure seekers. Over 90% of the country is covered by towering mountains, including the legendary Pamir Range, often called the “Roof of the World.”',
        },
        {
          id: 'Uzbekistan',
          title: 'Uzbekistan – The Jewel of the Silk Road',
          images: ['/uzb1.jpg', '/uzb2.jpg', '/uzb3.jpg', '/uzb4.jpg', '/uzb5.jpg', '/uzb6.jpg'],
          summary: 'Uzbekistan is a land of ancient cities, majestic mosques, blue-tiled madrasas, and vibrant bazaars. As a key stop along the legendary Silk Road, this Central Asian gem offers travelers a glimpse into a world of historic grandeur, Islamic architecture, and deeply rooted traditions.',
        }
      ];
      
      // Destination data for Europe
      export const europeanDestinations = [
        {
          id: 'albania',
          title: 'Albania: Europe’s Hidden Coastal & Mountain Gem',
          images: ['/alba1.jpg', '/alba2.jpg', '/alba3.jpg', '/alba4.jpg', '/alba5.jpg'],
          summary: 'Nestled in Southeastern Europe, Albania is a lesser known travel treasure offering stunning beaches, dramatic mountains, Ottoman-era towns, and ancient ruins all without the crowds (or costs) of its Mediterranean neighbors.',
        },
        {
          id: 'andorra',
          title: 'Andorra: Europe’s Hidden Snowy Paradise Between France and Spain',
          images: ['/ando1.jpg', '/ando2.jpg', '/ando3.jpg', '/ando4.jpg', '/ando5.jpg'],
          summary: 'Tucked away in the Pyrenees mountains, Andorra is one of Europe’s smallest countries, known for its spectacular ski slopes, tax-free shopping, and natural beauty.',
        },
        {
          id: 'austria',
          title: 'Austria: Where Fairytales, Alpine Peaks & Classical Music Come to Life',
          images: ['/austria1.jpg', '/austria2.jpg', '/austria3.jpg', '/austria4.jpg', '/austria5.jpg'],
          summary: 'Austria is a mesmerizing mix of imperial grandeur, snow-capped mountains, and artistic heritage. Whether you’re skiing in the Alps, waltzing in Vienna, or wandering through Sound of Music landscapes in Salzburg, Austria offers romance, culture, and natural beauty in perfect harmony.',
        },
        {
          id: 'belarus',
          title: 'Belarus: Eastern Europe’s Hidden Treasure of Soviet Echoes and Natural Beauty',
          images: ['/belar1.jpg', '/belar2.jpg', '/belar3.jpg', '/belar4.jpg', '/belar5.jpg'],
          summary: 'Belarus is a land of mysterious charm, vast forests, and fascinating Soviet history. With its clean cities, friendly locals, and offbeat experiences, this underrated country is a dream for travelers who love to go off the beaten path.',
        },
        {
          id: 'belgium',
          title: 'Belgium: Where Medieval Charm Meets Modern Marvels',
          images: ['/belgium1.jpg', '/belgium2.jpg', '/belgium3.jpg', '/belgium4.jpg', '/belgium5.jpg'],
          summary: 'Belgium is a captivating blend of historic cities, delectable cuisine, and vibrant cultures. From the cobblestone streets of Bruges to the bustling heart of Brussels, this European gem offers a rich tapestry of experiences for every traveler.',
        },
        {
          id: 'Bosnia and Herzegovina',
          title: 'Bosnia and Herzegovina: Where East Meets West in the Heart of the Balkans',
          images: ['/bh1.jpg', '/bh2.jpg', '/bh3.jpg', '/bh4.jpg', '/bh5.jpg'],
          summary: 'Bosnia and Herzegovina is a captivating blend of cultures, histories, and landscapes. From the Ottoman-influenced bazaars of Sarajevo to the medieval charm of Mostar, this country offers a unique journey through time and tradition.',
        },
        {
          id: 'Bulgaria',
          title: 'Bulgaria: Where History, Nature, and Culture Converge',
          images: ['/bulgaria1.jpg', '/bulgaria2.jpg', '/bulgaria3.jpg', '/bulgaria4.jpg', '/bulgaria5.jpg'],
          summary: 'Bulgaria is a captivating blend of ancient history, diverse landscapes, and rich traditions. From the vibrant streets of Sofia to the serene beaches of the Black Sea, this Balkan gem offers a unique experience for every traveler.',
        },
        {
          id: 'Croatia',
          title: 'Croatia: Where Coastal Beauty Meets Historic Charm',
          images: ['/cro1.jpg', '/cro2.jpg', '/cro3.jpg', '/cro4.jpg', '/cro5.jpg'],
          summary: 'Croatia is a stunning blend of sapphire blue seas, medieval towns, and vibrant cultural experiences. With over a thousand islands, pristine national parks, and UNESCO World Heritage Sites, this Mediterranean jewel attracts travelers seeking both relaxation and adventure.',
        },
        {
          id: 'Cyprus',
          title: 'Cyprus: Island of Sun, Sea & Stories from Two Worlds',
          images: ['/cyp1.jpg', '/cyp2.jpg', '/cyp3.jpg', '/cyp4.jpg', '/cyp5.jpg'],
          summary: 'Cyprus is a unique blend of stunning Mediterranean beaches, ancient ruins, charming villages, and a cultural fusion of Greek and Turkish influences. Known for its sunshine all year round and warm hospitality, Cyprus is a hidden gem for both leisure and culture-loving travelers.',
        },
        {
          id: 'Czech Republic',
          title: 'Czech Republic: Land of Castles, Cobblestones & World-Class Beer',
          images: ['/cz1.jpg', '/cz2.jpg', '/cz3.jpg', '/cz4.jpg', '/cz5.jpg'],
          summary: 'The Czech Republic, now often called Czechia, is a stunning Central European country famous for its fairy-tale architecture, medieval towns, thermal spas, hearty food, and legendary beer.',
        },
        {
          id: 'Denmark',
          title: 'Denmark: The Land of Hygge, Vikings, and Coastal Charm',
          images: ['/denm1.jpg', '/denm2.jpg', '/denm3.jpg', '/denm4.jpg', '/denm5.jpg'],
          summary: 'Denmark, the southernmost Scandinavian country, is known for its happy citizens, sustainable cities, fairy-tale castles, and a perfect blend of old-world charm and modern design.',
        },
        {
          id: 'Estonia',
          title: 'Estonia: The Digital Fairy Tale of Northern Europe',
          images: ['/esto1.jpg', '/esto2.jpg', '/esto3.jpg', '/esto4.jpg', '/esto5.jpg'],
          summary: 'Estonia is a small Baltic nation that feels like a beautiful blend of medieval charm and futuristic innovation. With cobblestone streets, pine forests, and one of the world’s most tech-savvy governments, Estonia is where Wi-Fi meets witchcraft.',
        },
        {
          id: 'Finland',
          title: 'Finland: Land of a Thousand Lakes and the Northern Lights',
          images: ['/fin1.jpg', '/fin2.jpg', '/fin3.jpg', '/fin4.jpg', '/fin5.jpg'],
          summary: 'Finland is where serene nature meets modern innovation, a land of forests, lakes, saunas, and Santa Claus! Its the ultimate destination for peace-seekers, adventure lovers, and design enthusiasts alike.',
        },
        {
          id: 'France',
          title: 'France: The Land of Love, Art, and Endless Baguettes',
          images: ['/france1.jpg', '/france2.jpg', '/france3.jpg', '/france4.jpg', '/france5.jpg', '/france6.jpg', '/france7.jpg', '/france8.jpg', '/france9.jpg'],
          summary: 'France is a timeless classic, a perfect blend of romantic cities, stunning countryside, rich history, gourmet cuisine, and iconic landmarks. Whether you’re sipping wine in Bordeaux, strolling through lavender fields in Provence, or skiing in the Alps, France has it all.',
        },
        {
          id: 'Germany',
          title: 'Germany:The Land of Castles, Culture & Currywurst!',
          images: ['/ger1.jpg', '/ger2.jpg', '/ger3.jpg', '/ger4.jpg', '/ger5.jpg','/ger6.jpg'],
          summary: 'Germany is where history meets innovation, a country of medieval towns, high-speed trains, fairytale castles, vibrant cities, and legendary festivals. Whether you are wandering through Berlins street art or sipping beer in Bavaria, Germany is a rich, diverse, and unforgettable experience.',
        },
        {
          id: 'Greece',
          title: 'Greece: The Land of Myths, Moussaka, and Magical Sunsets!',
          images: ['/greece1.jpg', '/greece2.jpg', '/greece3.jpg', '/greece4.jpg', '/greece5.jpg','/greece6.jpg'],
          summary: 'Greece is where ancient history meets island beauty. From the ruins of Athens to the cliffs of Santorini, it’s a dreamy escape of sunshine, sea, and stories.',
        },
        {
          id: 'Hungary',
          title: 'Hungary: The Land of Thermal Baths, Grand Architecture & Danube Dreams!',
          images: ['/hung1.jpg', '/hung2.jpg', '/hung3.jpg', '/hung4.jpg', '/hung5.jpg','/hung6.jpg'],
          summary: 'A perfect blend of elegance and energy, Hungary boasts magnificent cities, historical landmarks, healing waters, and a buzzing café culture, all wrapped up in Central European charm.',
        },
        {
          id: 'Iceland',
          title: 'Iceland: The Land of Fire & Ice – Where Nature Writes the Script!',
          images: ['/ice1.jpg', '/ice2.jpg', '/ice3.jpg', '/ice4.jpg', '/ice5.jpg','/ice6.jpg'],
          summary: 'A land of surreal beauty, geysers, glaciers, volcanoes, waterfalls, and the northern lights. Iceland is one of the most breathtaking and otherworldly countries on Earth. Every corner feels like a scene from a fantasy movie.',
        },
        {
          id: 'Ireland',
          title: 'Ireland: The Emerald Isle – A Magical Land of Myths, Music & Mesmerizing Landscapes!',
          images: ['/ire1.jpg', '/ire2.jpg', '/ire3.jpg', '/ire4.jpg', '/ire5.jpg','/ire6.jpg'],
          summary: 'Ireland is a place where lush green hills, dramatic coastlines, ancient castles, and a rich Celtic culture come together. Whether you are sipping Guinness in a cozy pub or driving through winding countryside roads, Ireland has a story at every turn.',
        },
        {
          id: 'Italy',
          title: 'Italy: La Dolce Vita – A Feast for the Senses with Art, Architecture, Pasta & Passion!',
          images: ['/italy1.jpg', '/italy2.jpg', '/italy3.jpg', '/italy4.jpg', '/italy5.jpg','/italy6.jpg','/italy7.jpg'],
          summary: 'Italy is a dream come true for travelers where history breathes, art lives, and food sings. Whether you are exploring ancient ruins, sailing along the Amalfi Coast, or indulging in gelato under the Tuscan sun, Italy has something magical for every kind of wanderer.',
        },
        {
          id: 'Kosovo',
          title: 'Kosovo – Europe’s Newest Hidden Gem!',
          images: ['/koso1.jpg', '/koso2.jpg', '/koso3.jpg', '/koso4.jpg', '/koso5.jpg'],
          summary: 'Kosovo is one of Europes youngest countries, offering a unique blend of natural beauty, ancient history, and vibrant modern culture, all waiting to be discovered by curious travelers.',
        },
        {
          id: 'Latvia',
          title: 'Latvia – Where Nature Meets Nordic Charm!',
          images: ['/lat1.jpg', '/lat2.jpg', '/lat3.jpg', '/lat4.jpg'],
          summary: 'Latvia, a hidden gem of the Baltics, offers a serene mix of medieval towns, vast pine forests, sandy beaches, and lively modern culture. Its where history whispers through cobbled streets, and nature is never far behind.',
        },
        {
          id: 'Liechtenstein',
          title: 'Liechtenstein – Europe’s Tiny Mountain Jewel!',
          images: ['/liech1.jpg', '/liech2.jpg', '/liech3.jpg', '/liech4.jpg', '/liech5.jpg'],
          summary: 'Liechtenstein, one of the world’s smallest countries, is a fairy-tale principality nestled in the Alps. It offers dramatic alpine views, medieval castles, and a charming quietude that makes you feel like you’ve stepped into a postcard.',
        },
        {
          id: 'Lithuania',
          title: 'Lithuania – The Hidden Gem of the Baltics!',
          images: ['/lithu1.jpg', '/lithu2.jpg', '/lithu3.jpg', '/lithu4.jpg', '/lithu5.jpg'],
          summary: 'Lithuania is a charming Baltic country blending medieval cities, lush forests, sand dunes, and a vibrant cultural spirit. It’s rich in history, yet trendy and modern.',
        },
        {
          id: 'Luxembourg',
          title: 'Luxembourg – A Small Country with Grand Experiences!',
          images: ['/luxem1.jpg', '/luxem2.jpg', '/luxem3.jpg', '/luxem4.jpg', '/luxem5.jpg'],
          summary: 'Luxembourg may be one of Europe’s smallest countries but it packs a punch with fairy-tale castles, forested trails and a stunningly preserved Old Town. Perfect for a short escape, it offers a unique mix of French elegance, German precision, and Belgian charm.',
        },
        {
          id: 'Malta',
          title: 'Malta – The Mediterranean Gem of Sun, Sea & History!',
          images: ['/malta1.jpg', '/malta2.jpg', '/malta3.jpg', '/malta4.jpg', '/malta5.jpg'],
          summary: 'Malta is a tiny island nation with a huge personality! Known for its turquoise waters, ancient ruins, colorful villages, and dramatic cliffs, Malta offers a perfect mix of relaxation, culture, and adventure in the heart of the Mediterranean Sea.',
        },
        {
          id: 'Moldova',
          title: 'Moldova – Europes Hidden Wine Paradise!',
          images: ['/moldo1.jpg', '/moldo3.jpg', '/moldo4.jpg', '/moldo5.jpg'],
          summary: 'Moldova is one of Europe’s least explored gems, but those who visit are rewarded with rolling vineyards, historic monasteries, warm hospitality, and authentic rural charm.',
        },
        {
          id: 'Monaco',
          title: 'Monaco – The Glamorous Jewel of the French Riviera!',
          images: ['/monaco1.jpg', '/monaco2.jpg', '/monaco3.jpg', '/monaco4.jpg', '/monaco5.jpg'],
          summary: 'Monaco is the second smallest country in the world, yet it packs a punch with luxury, royalty, yachts, casinos, and coastal beauty. A playground for the rich and famous, this city-state is known for its grand lifestyle, but also welcomes travelers looking for Mediterranean charm and scenic experiences.',
        },
        {
          id: 'Montenegro',
          title: 'Montenegro – The Adriatic’s Hidden Treasure!',
          images: ['/mont1.jpg', '/mont2.jpg', '/mont3.jpg', '/mont4.jpg', '/mont5.jpg','/mont6.jpg'],
          summary: 'Montenegro, a Balkan beauty, is a compact country packed with dramatic coastlines, majestic mountains, charming old towns, and underrated gems.',
        },
        {
          id: 'Netherlands',
          title: 'Netherlands – Land of Windmills, Waterways & Wonder!',
          images: ['/nether1.jpg', '/nether2.jpg', '/nether3.jpg', '/nether4.jpg', '/nether5.jpg','/nether6.jpg'],
          summary: 'The Netherlands is a picturesque country famous for its vibrant tulip fields, iconic windmills, charming canals and bike-friendly cities.',
        },
        {
          id: 'North Macedonia',
          title: 'North Macedonia – The Hidden Gem of the Balkans!',
          images: ['/nmac.jpg', '/nmac2.jpg', '/nmac3.jpg', '/nmac4.jpg', '/nmac5.jpg'],
          summary: 'North Macedonia is an underrated treasure in Southeastern Europe known for its lush mountains, ancient monasteries, vibrant culture and stunning lakes.',
        },
        {
          id: 'Norway',
          title: 'Norway – Land of Fjords, Northern Lights & Endless Daylight!',
          images: ['/norway1.jpg', '/norway2.jpg', '/norway3.jpg', '/norway4.jpg', '/norway5.jpg','/norway6.jpg'],
          summary: 'Norway is a land of stunning natural beauty, home to majestic fjords, snow-capped mountains, the Midnight Sun, and the ethereal Northern Lights. With a deep-rooted Viking history, sustainable living, and world-class outdoor adventures, Norway is perfect for nature lovers and explorers.',
        },
        {
          id: 'Poland',
          title: 'Poland – A Hidden Gem of History, Culture & Nature!',
          images: ['/pola1.jpg', '/pola2.jpg', '/pola3.jpg', '/pola4.jpg', '/pola5.jpg'],
          summary: 'Poland is a stunning blend of medieval cities, charming towns, scenic mountains, and war-torn yet resilient history. From fairy-tale architecture and vibrant squares to sobering reminders of WWII, Poland offers travelers a rich cultural experience at surprisingly affordable prices.',
        },
        {
          id: 'Portugal',
          title: 'Portugal – A Tapestry of Timeless Charm, Coastal Beauty & Culinary Delights!',
          images: ['/portu1.jpg', '/portu2.jpg', '/portu3.jpg', '/portu4.jpg', '/portu5.jpg'],
          summary: 'Portugal is a captivating blend of historic cities, sun-kissed beaches, rolling vineyards, and vibrant culture. From the cobbled streets of Lisbon to the dramatic cliffs of the Algarve, this Iberian gem offers a rich tapestry of experiences for every traveler.',
        },
        {
          id: 'Romania',
          title: 'Romania – Land of Castles, Carpathians & Timeless Traditions!',
          images: ['/roman1.jpg', '/roman2.jpg', '/roman3.jpg', '/roman4.jpg', '/roman5.jpg'],
          summary: 'Romania is a mystical destination filled with medieval towns, fairy-tale castles, forests, and vibrant traditions. With the legend of Dracula, the beauty of the Carpathian Mountains, and the charm of Transylvanian villages, Romania offers an unforgettable European experience that blends history, nature, and folklore.',
        },
        {
          id: 'San Marino',
          title: 'San Marino – The Serene Republic in the Clouds!',
          images: ['/sanmar1.jpg', '/sanmar2.jpg', '/sanmar3.jpg', '/sanmar4.jpg', '/sanmar5.jpg'],
          summary: 'Welcome to San Marino, one of the world’s oldest republics, nestled on the slopes of Mount Titano and offering dramatic views, medieval charm, and timeless traditions.',
        },
        {
          id: 'Serbia',
          title: 'Serbia – The Soul of the Balkans!',
          images: ['/serbia1.jpg', '/serbia2.jpg', '/serbia3.jpg', '/serbia4.jpg', '/serbia5.jpg'],
          summary: 'Serbia is a vibrant, landlocked country in Southeast Europe known for its electric nightlife, historic cities, natural beauty and warm-hearted people.',
        },
        {
          id: 'Slovakia',
          title: 'Slovakia – Castles, Caves, and Carpathian Magic!',
          images: ['/slovek1.jpg', '/slovek2.jpg', '/slovek3.jpg', '/slovek4.jpg', '/slovek5.jpg'],
          summary: 'Tucked in the heart of Central Europe, Slovakia is a treasure trove of fairy-tale castles, mountain adventures and charming medieval towns.',
        },
        {
          id: 'Slovenia',
          title: 'Slovenia – Nature’s Hidden Paradise in Europe!',
          images: ['/slovenia1.jpg', '/slovenia2.jpg', '/slovenia3.jpg', '/slovenia4.jpg', '/slovenia5.jpg'],
          summary: 'Slovenia is a compact yet incredibly diverse gem of Europe that blends Alpine peaks, fairytale lakes, underground caves and vibrant cities.',
        },
        {
          id: 'Spain',
          title: 'Spain – A Colorful Blend of Culture, Coastlines & Cuisine!',
          images: ['/spain1.jpg', '/spain2.jpg', '/spain3.jpg', '/spain4.jpg', '/spain5.jpg','/spain6.jpg'],
          summary: 'Spain is a land of passion, vibrant traditions, delicious food and sun-kissed coastlines. From the flamenco-filled streets of Seville to the architectural marvels of Barcelona, Spain offers a journey full of art, festivals, beaches, and unforgettable flavors.',
        },
        {
          id: 'Sweden',
          title: 'Sweden – A Nordic Dream of Nature, Design & Serenity!',
          images: ['/swe1.jpg', '/swe2.jpg', '/swe3.jpg', '/swe4.jpg', '/swe5.jpg','/swe6.jpg'],
          summary: 'Sweden is where modern innovation meets untouched natural beauty. With its crystal-clear lakes, cozy fika culture, minimalist design, and enchanting northern lights, Sweden offers a calm yet captivating travel experience for every explorer.',
        },
        {
          id: 'Switzerland',
          title: 'Switzerland – A Fairytale Land of Alps, Lakes & Luxury!',
          images: ['/swit1.jpg', '/swit2.jpg', '/swit3.jpg', '/swit4.jpg', '/swit5.jpg','/swit6.jpg'],
          summary: 'Switzerland is where snow-capped mountains, turquoise lakes, and precision meet. With its storybook villages, scenic train rides, and delicious chocolates, Switzerland offers the ultimate European escape – both peaceful and luxurious.',
        },
        {
          id: 'Ukraine',
          title: 'Ukraine – A Land of Resilience, Culture & Hidden Beauty!',
          images: ['/ukr1.jpg', '/ukr2.jpg', '/ukr3.jpg', '/ukr4.jpg', '/ukr5.jpg'],
          summary: 'Ukraine is a country where history whispers from ancient cathedrals, sunflowers stretch across golden fields, and cities buzz with youthful creativity. From the romantic streets of Lviv to the grand squares of Kyiv, Ukraine is an underrated gem waiting to be explored.',
        },
        {
          id: 'United Kingdom',
          title: 'United Kingdom – Timeless Charm, Royal Heritage & Modern Cool!',
          images: ['/uk1.jpg', '/uk2.jpg', '/uk3.jpg', '/uk4.jpg', '/uk5.jpg', '/uk6.jpg', '/uk7.jpg'],
          summary: 'The United Kingdom is a land of regal castles, quaint countryside, world-class museums, and cutting-edge culture. From sipping tea in London to hiking the Scottish Highlands or enjoying pub vibes in Dublin, the UK promises a blend of old-world elegance and contemporary flair.',
        },
        {
          
          id: 'Vatican City',
          title: 'Vatican City – The World’s Smallest Country with the Grandest Heritage!',
          images: ['/vc1.jpg', '/vc2.jpg', '/vc3.jpg', '/vc4.jpg', '/vc5.jpg'],
          summary: 'Step into the spiritual heart of Christianity and one of the most iconic places on Earth – Vatican City. Though it’s the smallest country in the world, it holds monumental treasures from the awe-inspiring St. Peter’s Basilica to the breathtaking Sistine Chapel.',
        }



        
      ];
    
